<template>
	<div>
		<button class="ts-flex ts-items-center ts-bg-blue-100 ts-text-blue-500 ts-px-3 ts-space-x-1 ts-rounded focus:ts-outline-none" style="height: 2.2rem;">
			<p>{{ $t('dailyCloseout.propertiesVisibility') }}</p>
			<p>123</p>
			<i class="fas fa-caret-down"></i>
		</button>
	</div>
</template>


<template>
	<div>
		<a-popover trigger="click" placement="bottomLeft">
			<button
				class="ts-flex ts-items-center ts-bg-blue-100 ts-text-blue-500 ts-px-3 ts-space-x-1 ts-rounded focus:ts-outline-none"
				style="height: 2.2rem;">
				<p>{{ $t('dailyCloseout.propertiesVisibility') }}</p>
				<p>{{ countVisible }}</p>
				<i class="fas fa-caret-down"></i>
			</button>
			<template #content>
				<div class="ts-p-1">
					<a-input v-model="search" :placeholder="$t('dailyCloseout.search')" class="ts-mb-2"></a-input>
					<draggable v-model="colsModel.cols" handle=".handle" @end="onEndMove">

						<div class="ts-flex ts-space-x-1 ts-space-y-2 ts-items-center hover:ts-bg-gray-100 ts-duration-200"
							v-for="item in colsModel.cols">
							<div
								class="ts-py-1 ts-rounded hover:ts-bg-gray-200 hover:ts-text-gray-700 ts-duration-200 ts-px-2 ts-space-x-2 ts-flex ts-w-full ts-justify-between">
								<div>
									<div class="ts-justify-center ts-items-center ts-flex ts-space-x-2">
										<i class="fas fa-grip-vertical handle"></i>
										<p>{{ $t(`dailyCloseout.${item.label}`) }}</p>
									</div>
								</div>
								<button class="ts-flex ts-items-center ts-justify-center ts-cursor-pointer focus:ts-outline-none"
									@click="hideShow(item)">
									<i class="far fa-eye" v-if="findKey(item) >= 0"></i>
									<i class="fas fa-eye-slash" v-else></i>
								</button>
							</div>
						</div>
					</draggable>
				</div>
			</template>
		</a-popover>
	</div>
</template>

<script>
import draggable from 'vuedraggable';
import { columns } from '../config';

export default {
	name: 'visibleComponent',
	props: ['value', 'cols'],
	components: {
		draggable,
	},
	data() {
		return {
			model: {},
			colsModel: [],
			search: undefined
		}
	},
	created() {
		this.model = this.value
		this.colsModel = this.cols
	},
	computed: {
		findKey: vm => item => {
			return vm.model.visible.findIndex(el => el === item.key || item.slot)
		},
		countVisible() {
			return this.model.visible.length
		},
		columnItems() {
			const search = (this.search || '').toLowerCase()
			return columns()
				.map(el => ({
					value: el.key || el.col,
					label: this.$t(`dailyCloseout.${el.label}`),
					type: el.type
				}))
				.filter(item => item.label.toLowerCase().includes(search))
		},
		groupByDisplay() {
			const findName = this.columnItems.find(el => el.value === this.model.groupBy)
			if (findName) {
				return findName.label
			}
			return ''
		}
	},
	methods: {
		onAddHandler(item) {
			this.model.groupBy = item.value
		},
		hideShow(item) {
			const index = this.model.visible.findIndex(el => el === item.key)
			if (index !== -1) {
				this.model.visible.splice(index, 1)
			} else {
				this.model.visible.push(item.key)
			}

			localStorage.setItem('daily_closeout_report_visible', JSON.stringify(this.model.visible))
		},
		onEndMove(_newOrder) {
			localStorage.setItem('daily_closeout_report_visible_order', JSON.stringify(this.colsModel.cols))
		}
	}
}
</script>

<style scoped>
.visible-grid {
	display: grid;
	grid-template-columns: 30px auto 30px;
	column-gap: 10px;
}

.handle {
	cursor: grab;
	/* Grab cursor for the handle only */
	color: #666;
}

.handle:active {
	cursor: grabbing;
}
</style>